<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="#56C0EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6.5 23 10 19.5 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path><text x="12" y="14.5" fill="currentColor" stroke="none" font-size="7" font-weight="700" text-anchor="middle" font-family="inherit">10</text></svg>
</template>

<script>
export default {
  name: 'IconForward10'
}
</script>
